import { ApiRoute } from './apiRoute';
import { QueryParams } from './queryParams';

export function createApiRoute<T extends Record<string, any>>(path: string): ApiRoute<T> {
  return {
    path,
    build: (queryParams?: QueryParams<T>) => {
      if (!queryParams) return path;

      const queryString = Object.entries(queryParams)
        .map(([key, value]) => {
          if (value !== undefined && value !== null) {
            if (Array.isArray(value)) {
              return value.map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(String(v))}`).join('&');
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
          }
          return '';
        })
        .filter((param) => param !== '') // Filter out empty strings in case of undefined or null values
        .join('&');

      return queryString ? `${path}?${queryString}` : path;
    }
  };
}
